// /app/frontend/src/api/adminRoomReports.js
import api from "./client";

export async function listRoomReports({ status = "open", limit = 50, skip = 0 } = {}) {
  const res = await api.get("/admin/room-reports", { params: { status, limit, skip } });
  return res.data;
}

export async function updateRoomReport(reportId, { status, admin_note = "" }) {
  const res = await api.patch(`/admin/room-reports/${reportId}`, { status, admin_note });
  return res.data;
}

export async function deleteRoomPost(postId) {
  const res = await api.delete(`/admin/room-reports/posts/${postId}`);
  return res.data;
}

export async function deleteRoomReply(replyId) {
  const res = await api.delete(`/admin/room-reports/replies/${replyId}`);
  return res.data;
}
